var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pictureads",style:({
    '--color': _vm.pointActiveColor,
    '--pointColor': _vm.pointUnActiveColor,
    '--arrowColor': _vm.arrowBgColor,
  })},[_c('div',{style:({
      background: _vm.datas.backColor,
      'padding-top': _vm.datas.paddingTop + 'px',
      'padding-bottom': _vm.datas.paddingBottom + 'px',
      'padding-left': _vm.datas.paddingLeft + 'px',
      'padding-right': _vm.datas.paddingRight + 'px',
      'border-style': _vm.datas.borderStyle,
      'border-color': _vm.datas.borderColor,
      'border-width': _vm.datas.borderLineWeight + 'px',
      'border-radius': _vm.datas.borderRadius + 'px',
      'margin-top': _vm.datas.marginTop + 'px',
      'margin-bottom': _vm.datas.marginBottom + 'px',
      'margin-left': _vm.datas.marginLeft + 'px',
      'margin-right': _vm.datas.marginRight + 'px',
    })},[(!_vm.imageList[0])?_c('div',{staticClass:"upload"},[_c('img',{attrs:{"src":require("@/assets/images/defaultPic2.png"),"alt":""}})]):_vm._e(),(_vm.imageList[0])?_c('div',{staticClass:"swiper-container"},[_c('div',{class:_vm.styleType === 4 || _vm.styleType === 5
            ? 'type3 swiper-wrapper'
            : 'swiper-wrapper '},_vm._l((_vm.imageList),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide",on:{"click":function($event){return _vm.handleClickImg(item)}}},[_c('img',{style:({
              'border-bottom-left-radius':
                _vm.styleType === 2 ? '40% 20%' : '0 0',
              'border-bottom-right-radius':
                _vm.styleType === 2 ? '40% 20%' : '0 0',
            }),attrs:{"src":item.imgUrl,"alt":"","draggable":"false"}}),(_vm.styleType === 3)?_c('div',{staticClass:"circle"}):_vm._e()])}),0),(_vm.styleType === 1 || _vm.styleType === 2 || _vm.styleType === 3)?_c('div',{staticClass:"swiper-pagination"}):_vm._e(),(_vm.styleType === 6)?_c('div',{staticClass:"swiper-button-prev"},[_c('i',{staticClass:"iconfont icon-houtui"})]):_vm._e(),(_vm.styleType === 6)?_c('div',{staticClass:"swiper-button-next"},[_c('i',{staticClass:"iconfont icon-qianjin"})]):_vm._e()]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }